<!-- Slider -->

<div class="bd-example">
  <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
      <div class="carousel-indicators">
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-label="Slide 1"></button>
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2" aria-current="true"></button>
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="4" aria-label="Slide 5"></button>
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="5" aria-label="Slide 6"></button>
        <!-- <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="6" aria-label="Slide 7"></button>
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="7" aria-label="Slide 8"></button> -->
      </div>
    <div class="carousel-inner">
    <div class="carousel-item active ">
      <div class="container">
        <div class="row g-0 align-items-center">
          <div class="col-12 col-lg-6 slideContent">
            <span class="surTitreSlider">Série Vox</span>
            <p class="dataSeries">Par son aspect quasi-naturel, le spray s’imprègne des tendances actuelles. Grâce à son design clair et élégant, il apporte une touche artistique et embellit votre espace de vie.</p>

          </div>
          <div class="col-12 col-lg-6">
            <div style="background-image:url('assets/front/images/vox-bg.jpg');" class="backgroundSerie">

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="carousel-item ">
      <div class="container">
        <div class="row g-0 align-items-center">
          <div class="col-12 col-lg-6 slideContent">
            <span class="surTitreSlider">Série RIO</span>
            <p class="dataSeries">Une forme fonctionnelle et esthétique, son aspect angulaire et élégant avec un design parfaitement pratique, vous offre des moments de pur confort.</p>
          </div>
          <div class="col-12 col-lg-6">
            <div style="background-image:url('assets/front/images/rio-bg.jpg');" class="backgroundSerie">

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="carousel-item" >
      <div class="container">
        <div class="row g-0 align-items-center">
          <div class="col-12 col-lg-6 slideContent">
            <span class="surTitreSlider">Série STILL</span>
            <p class="dataSeries">Un modèle gracieux et moderne dans son style, pour orner vos salles de bains.</p>
          </div>
          <div class="col-12 col-lg-6">
            <div style="background-image:url('assets/front/images/still-bg.jpg');" class="backgroundSerie">

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="carousel-item" >
      <div class="container">
        <div class="row g-0 align-items-center">
          <div class="col-12 col-lg-6 slideContent">
            <span class="surTitreSlider">Série VERSAILLE</span>
            <p class="dataSeries">Imperméable et anti-rouille, solide et facile à nettoyer. Dotée d’une apparence esthétique pleine de sensations, pour un écoulement lisse et doux.</p>
          </div>
          <div class="col-12 col-lg-6">
            <div style="background-image:url('assets/front/images/versaille-bg.jpg');" class="backgroundSerie">

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="carousel-item ">
      <div class="container">
        <div class="row g-0 align-items-center">
          <div class="col-12 col-lg-6 slideContent">
            <span class="surTitreSlider">Série SILVIA</span>
            <p class="dataSeries">Le revêtement résistant, ainsi que la protection anti-rouille prolongent la durée de vie de la matière et conservent sa brillance le plus longtemps possible.</p>
          </div>
          <div class="col-12 col-lg-6">
            <div style="background-image:url('assets/front/images/silvia-bg.jpg');" class="backgroundSerie">

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="carousel-item ">
      <div class="container">
        <div class="row g-0 align-items-center">
          <div class="col-6 slideContent">
            <span class="surTitreSlider">Série PLUS</span>
            <p class="dataSeries">Chaque inclinaison exprime un aspect unique, lumineux et élégant. Ses courbes faciles à manipuler donnent un vrai charme à vos gestes quotidiens.</p>
          </div>
          <div class="col-6">
            <div style="background-image:url('assets/front/images/plus-bg.jpg');" class="backgroundSerie">

            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- <div class="carousel-item " style="background-image:url('assets/front/images/nadafa-bg.jpg');" >
      <div class="container">
        <div class="row justify-content-start">
          <div class="col-sm-8 slideContent">
            <span class="surTitreSlider">NADAFA Série</span>
            <p class="dataSeries">Une robinetterie adaptée à tout type de salle de bain, qu’il s’agisse d’un style luxueux ou classique.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="carousel-item " style="background-image:url('assets/front/images/nadafa-bg.jpg');" >
      <div class="container">
        <div class="row justify-content-start">
          <div class="col-sm-8 slideContent">
            <span class="surTitreSlider">NOIR PLUS Série</span>
            <p class="dataSeries">La robinetterie noir, détail ultra chic, une touche raffinée à emprunter ! Pour la robinetterie de cuisine, de douche, de baignoire ou de lavabo.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="carousel-item " style="background-image:url('assets/front/images/nadafa-bg.jpg');" >
      <div class="container">
        <div class="row justify-content-start">
          <div class="col-sm-8 slideContent">
            <span class="surTitreSlider">NINA Série</span>
            <p class="dataSeries">Avec une robinetterie laiton dans la douche, une touche d’élégance intemporelle, le plus simple des matériaux muraux sera sublimé.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="carousel-item " style="background-image:url('assets/front/images/nadafa-bg.jpg');" >
      <div class="container">
        <div class="row justify-content-start">
          <div class="col-sm-8 slideContent">
            <span class="surTitreSlider">NOA Série</span>
            <p class="dataSeries">Un design haut de gamme à intégrer dans vos salles de bains, douches et cuisines pour un look contemporain.</p>
            <button class="btn voirPlusBtnRouge">Découvrir <i class="fa fa-chevron-right" aria-hidden="true"></i></button>
          </div>
        </div>
      </div>
    </div> -->
      <!-- <div class="carousel-item " style="background-image:url('assets/front/images/bgslide.jpg');" >
        <div class="container">
          <div class="row">
            <div class="col-sm-8 slideContent">
              <span class="surTitreSlider">C'EST UN MODE DE VIE</span>
              <h2 class="titreSlider">DÉCOUVREZ NOTRE COLLECTION</h2>
              <h3 class="titreSlider2">DE ROBINETS MÉLANGEUR</h3>
              <h2 class="titreSlider3">REMISE DE 70% AUX 30 PREMIERS CLIENTS</h2>
              <button class="btn voirPlusBtnRouge">ACHETER MAINTENANT <i class="fa fa-chevron-right" aria-hidden="true"></i></button>
            </div>
            <div class="col-sm-4">

            </div>
          </div>
        </div>
      </div>
      <div class="carousel-item " style="background-image:url('assets/front/images/bgslide.jpg');" >
        <div class="container">
          <div class="row">
            <div class="col-sm-8 slideContent">
              <span class="surTitreSlider">C'EST UN MODE DE VIE</span>
              <h2 class="titreSlider">DÉCOUVREZ NOTRE COLLECTION</h2>
              <h3 class="titreSlider2">DE ROBINETS MÉLANGEUR</h3>
              <h2 class="titreSlider3">REMISE DE 70% AUX 30 PREMIERS CLIENTS</h2>
              <button class="btn voirPlusBtnRouge">ACHETER MAINTENANT <i class="fa fa-chevron-right" aria-hidden="true"></i></button>
            </div>
            <div class="col-sm-4">

            </div>
          </div>
        </div>
      </div> -->
    </div>
    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Previous</span>
    </button>
    <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Next</span>
    </button>
</div>
</div>
<!-- Fin Slider -->
<div class="container-fluid slideCat mt-3">
         <!-- breadcrumb -->
      <div class="container">
        <div class="row slideContenu">
            <!-- Fin breadcrumb -->
        <!-- Bloc Slide -->

            <div class="col-sm-12">
                <div class="textSlide">
                  <p><img src="assets/front/images/robimedlogodark.png" /></p>
                  <h3>Faucet Technologies</h3>
                  <p class="description">En tant qu’ambassadeur des équipements sanitaires au Maroc, et grâce à notre expérience de plus de 25 ans, nous nous sommes engagés à introduire sur le marché des produits faciles à exploiter, et viables en qualité.
Nous sommes particulièrement attentifs à une utilisation quotidienne irréprochable, qui tient en compte l’économie d’eau et la protection de l'environnement. De ce fait, nous tenons à ce que chacun de nos produits représente l’harmonie parfaite de technologie, de qualité et de design.
</p>
                  <a href="/robimeds#robiproducts"><button class="btnCata">Découvrez nos produits</button></a>
                </div>
            </div>
        </div>
      </div>
    </div>
      <!-- Fin Bloc Slide -->
      <div class="container">
        <!--Début Produits Robimed-->
        <div class="row produitRobimed">
            <div class="col-sm-12 titreRubrique text-center">
                Produits Robimed
               <div class="separTitres"></div>
            </div>
         </div>
            <div class="row listeProduct" id="robiproducts">
              <div class="col-sm-12 triProducts mb-4 text-end">
                <div class="triAffichage">
                  Affichage :
                  <select class="form-select selectAffichage" (change)="changeMax($event.target.value)" aria-label="Default select example">
                    <option value="12">x 12 Produits</option>
                    <option value="22">x 22 Produits</option>
                    <option value="44">x 44 Produits</option>
                    <option value="88">x 88 Produits</option>
                  </select>
                </div>
              </div>
              <!-- list products -->
              <div class="col-sm-4" *ngFor="let product of productsByMarque | paginate: {itemsPerPage: pageSize,currentPage: page,totalItems: total }">
                <!-- <div class="newProductContainer">
                  <a [routerLink]="['/product-details/',product.ITMREF]" class="ProductImgContainer">
                    <img onerror="this.onerror=null;this.src='assets/front/images/logo.png';"  src="http://162.213.250.33/ceratube/assets/images/product-img/{{product.VIG}}" class="img-fluid ProductImg" />
                  </a>
                  <div class="productData">
                    <div class="productIcons text-center">
                      <a href="#" class="likeAction productActions">
                        <span class="fa-stack fa-lg">
                          <i class="fa fa-circle fa-stack-2x"></i>
                          <i class="fa fa-heart fa-stack-1x fa-inverse"></i>
                        </span>
                      </a>
                      <a href="#" class="viewAction productActions">
                        <span class="fa-stack fa-lg">
                          <i class="fa fa-circle fa-stack-2x"></i>
                          <i class="fa fa-eye fa-stack-1x fa-inverse"></i>
                        </span>
                      </a>
                      <a href="#" class="addtocartAction productActions">
                        <div class="viewAction">
                          <span class="fa-stack fa-lg">
                            <i class="fa fa-circle fa-stack-2x"></i>
                            <i class="fa fa-shopping-cart fa-eye fa-stack-1x fa-inverse"></i>
                          </span>
                        </div>
                      </a>
                    </div>
                    <a [routerLink]="['product-details/',product.ITMREF]" class="productDetails">
                      <div class="productTitle text-center">
                        {{product.ITMDES1}}
                      </div>
                      <div class="productPrice text-center">
                        <strong>{{product.PRIXNET}}</strong> MAD
                      </div>
                    </a>
                  </div>
                </div> -->
                <app-card-product [product]="product" ></app-card-product>
              </div>


              <pagination-controls class="text-center" (pageChange)="page = $event"></pagination-controls>
            </div>
        <!--Fin produits Robimed-->
      </div>
